import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import whiteCheck from '@/images/white-checkbox-check.svg';

export const CheckboxInput = styled('input')`
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  font-size: 1.5em;
  color: ${({ theme }) => theme.color.radioButtonSecondary};
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  border: 2px solid ${({ theme }) => theme.color.radioButtonSecondary};
  border-radius: ${pxToRem(4)};
  transform: translateY(-0.075em);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  &:checked {
    background-color: ${({ theme }) => theme.color.radioButtonPrimary};
    border: ${({ theme }) => `2px solid ${theme.color.radioButtonPrimary}`};

    &:after {
      content: url(${whiteCheck.src});
      position: absolute;
      object-fit: cover;
      width: ${pxToRem(24)};
      height: ${pxToRem(24)};
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.color.white};

      ${mediaQueries[0]} {
        bottom: 0;
      }

      ${mediaQueries.min} {
        bottom: 0;
      }

      ${mediaQueries.mobile} {
        bottom: ${pxToRem(2)};
      }

      ${mediaQueries.tablet} {
        bottom: 0;
      }
    }
  }
`;

export const RadioInput = styled('input')<{
  checked: boolean;
}>`
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  font-size: 1.5em;
  color: ${({ theme }) => theme.color.radioButtonSecondary};
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  border: 2px solid ${({ theme }) => theme.color.radioButtonSecondary};
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
  cursor: pointer;

  &::before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    border-radius: 50%;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em ${({ theme }) => theme.color.radioButtonPrimary};
    transform: ${({ checked }) => (checked ? 'scale(1)' : 'scale(0)')};
  }
`;

export const StyledLabel = styled('label')`
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: ${({ theme }) => theme.lineHeight.m};
  font-weight: 400;
  cursor: pointer;
`;
